import React from 'react';
import { Link } from "react-router-dom";
import css from './ProjectItem.module.scss';


export default function ProjectItem({title, description, position, img, link}) {
  return (
    <li className={css.projectItem}>
      <Link to={link}>
      <img src={img}  alt={title} />
      <h4>{title}</h4>
      <p>{description}</p>
      <small>{position}</small>
      </Link>
    </li>
  )
}
